<template>
  <div>
    <a-drawer :width="900" :visible="visible" :ok-button-props="{ props: { loading: loading } }" :body-style="{ paddingBottom: '80px' }" @close="close">
      <template slot="title">
        {{ title }}
      </template>
      <a-form-model ref="form" layout="horizontal" :model="formData" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="追溯名称" prop="title" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <a-input
            v-model.trim="formData.title"
            :disabled="!['use','value'].includes(type)"
            :max-length="50"
            placeholder="请给你的追溯起一个名字(最多不超过50个字符)"
          />
        </a-form-model-item>
        <a-row>
          <a-col v-if="['use','value'].includes(type)" :span="12">
            <a-form-model-item
              :label="type==='use'?'需求应用时间':'开始时间'"
              prop="startTime"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-date-picker v-model="formData.startTime" placeholder="请选择时间" value-format="YYYY-MM-DD" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="['value'].includes(type)" :span="12">
            <a-form-model-item label="追溯结束时间" prop="endTime" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <a-date-picker v-model="formData.endTime" placeholder="请选择时间" value-format="YYYY-MM-DD" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item v-if="['value'].includes(type)" label="追溯信息" prop="retrospectDoc" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <VditorEditor v-model="formData.retrospectDoc" :height="200" :width="700" />
        </a-form-model-item>
        <a-form-model-item v-if="['use','value'].includes(type)" label="追溯附件" prop="files" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <UploadFile :key="key" :is-edit="true" :data-list.sync="formData.files" @startUpdate="fileUpdate(true)" @endUpdate="fileUpdate(false)" />
        </a-form-model-item>
        <a-form-model-item v-if="['use','value'].includes(type)" label="相关图片" prop="images" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <UploadImg :key="key" :is-edit="true" :data-list.sync="formData.images" @startUpdate="imgUpdate(true)" @endUpdate="imgUpdate(false)" />
        </a-form-model-item>
        <a-form-model-item v-if="['value_conclusion'].includes(type)" label="是否符合预期" prop="valueIsReach" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <a-radio-group v-model="formData.valueIsReach">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-if="['use_conclusion','value_conclusion'].includes(type)"
          label="追溯小结"
          prop="conclusionDoc"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 21 }"
        >
          <VditorEditor v-model="formData.conclusionDoc" :height="200" :width="700" />
        </a-form-model-item>
        <a-form-model-item
          v-if="['value_conclusion'].includes(type)"
          label="后续计划"
          prop="afterPlanDoc"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 21 }"
        >
          <VditorEditor v-model="formData.afterPlanDoc" :height="200" :width="700" />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="close"> 取消 </a-button>
        <a-button :loading="loading" type="primary" @click="onSubmit"> {{ loading ? '提交中' : '提交' }} </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import UploadImg from '@/pages/business/requirement/components/UploadImg';
import UploadFile from '@/pages/business/requirement/components/UploadFile';
import moment from 'moment';
import { createBrRetrospect, updateBrRetrospect } from '@/api/business/requirement';
import VditorEditor from '@/components/VditorEditor';

export default {
  components: { UploadImg, UploadFile, VditorEditor },
  props: {
    brId: {
      type: Number || null,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      projectId: 0,
      formData: {
        id: 0,
        title: '',
        brId: this.brId,
        type: 1,
        images: [],
        files: [],
        startTime: '',
        endTime: '',
        valueIsReach: null,
        retrospectDoc: '',
        conclusionDoc: '',
        afterPlanDoc: ''
      },
      fileIsUpdate: false,
      imgIsUpdate: false,
      type: 'use',
      isEdit: false,
      key: 0,
      rules: {
        title: [
          { required: true, message: '标题不能为空哦~', trigger: 'blur' }
        ]
        // startTime: [{ required: true, message: '时间不能为空', trigger: 'blur' }],
        // endTime: [{ required: true, message: '时间不能为空', trigger: 'blur' }],
        // retrospectDoc: [{ required: true, message: '追溯信息不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    title() {
      let t = this.isEdit ? '编辑' : '新增';
      if (this.type === 'use') {
        t = t + '应用追溯信息';
      } else if (this.type === 'use_conclusion') {
        t = t + '应用追溯小结';
      } else if (this.type === 'value') {
        t = t + '价值追溯信息';
      } else if (this.type === 'value_conclusion') {
        t = t + '价值追溯小结';
      }
      return t;
    }
  },
  created() {

  },
  destroyed() {
  },
  methods: {
    onOpen(type, isEdit, record) {
      this.type = type;
      this.isEdit = isEdit;
      this.visible = true;
      if (isEdit) {
        this.formData = JSON.parse(JSON.stringify(record));
      } else {
        this.formData = {
          id: 0,
          title: '追溯阶段',
          brId: this.brId,
          type: 2,
          images: [],
          files: [],
          startTime: '',
          endTime: '',
          valueIsReach: null,
          retrospectDoc: '',
          conclusionDoc: '',
          afterPlanDoc: ''
        };
      }
    },
    fileUpdate(isUpdate) {
      this.fileIsUpdate = isUpdate;
    },
    imgUpdate(isUpdate) {
      this.imgIsUpdate = isUpdate;
    },
    onReload() {
      this.$emit('onReload');
    },
    close() {
      this.visible = false;
      this.loading = false;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day');
    },
    onSubmit() {
      if (this.fileIsUpdate) {
        this.$message.error('请等待文件上传完成');
        return;
      }
      if (this.imgIsUpdate) {
        this.$message.error('请等待图片上传完成');
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          const formData = JSON.parse(JSON.stringify(this.formData));
          formData.brId = this.brId;
          // 添加业务需求
          if (this.isEdit) {
            updateBrRetrospect(formData)
              .then(() => {
                this.$emit('saveOK');
                this.$message.success('保存成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            createBrRetrospect(formData)
              .then(() => {
                this.$emit('saveOK');
                this.$message.success('添加成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    initData() {

    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 12px;
}
// /deep/.ant-form-item-label {
//   line-height: 32px;
// }
.submit {
  width: 100px;
  margin: 0 auto;
}
/deep/.ant-modal-body {
  padding: 8px 48px 16px 48px;
}
</style>
